import React from 'react';

import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonNext,
  ButtonBack,
} from 'pure-react-carousel';
import '../../node_modules/pure-react-carousel/dist/react-carousel.es.css';
import '../styles/HeaderCarsoul.css';
import { PlayCircleOutline, DoubleArrow } from '@material-ui/icons';

const HeaderCarsoul = () => {
  return (
    <div>
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={50}
        totalSlides={3}
      >
        <Slider>
          <Slide index={0}>
            <div
              className="poster"
              style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center ',
                backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 90%,
            rgba(21,30,47,1)), url(https://www.hdwallback.net/wp-content/uploads/2015/07/deadpool-movie-poster.jpg}`,
              }}
            >
              <div className="poster__left">
                <img src="" alt="" />
                <h1>Video Title</h1>
                <h3>Video Description</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae
                  eligendi expedita facere placeat error magni.
                </p>
              </div>

              <div className="poster__right">
                <div className="poster__right__play">
                  <PlayCircleOutline className="poster__icons" />
                  <strong>Latest</strong>
                </div>
                <ButtonNext className="poster__button">
                  <DoubleArrow className="poster__icons" />
                </ButtonNext>
              </div>
            </div>
          </Slide>
          <Slide index={1}>
            <div
              className="poster-1"
              style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center ',
                backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 90%,
            rgba(21,30,47,1)), url('https://i.pinimg.com/originals/e4/ba/0f/e4ba0f8c5357303255009b90bb08cd47.jpg')`,
              }}
            >
              <div className="poster-1__left">
                <div className="poster-1__top">
                  <h1>Video Title</h1>
                  <h3>Video Description</h3>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Quae eligendi expedita facere placeat error magni.
                  </p>
                </div>
                <div className="poster-1__bottom">
                  <ButtonBack className="poster__back">
                    <DoubleArrow className="poster__backButton" />
                  </ButtonBack>
                </div>
              </div>

              <div className="poster-1__right">
                <div className="poster__right__play">
                  <PlayCircleOutline className="poster__icons" />
                  <strong>Latest</strong>
                </div>
                <ButtonNext className="poster__button">
                  <DoubleArrow className="poster__icons" />
                </ButtonNext>
              </div>
            </div>
          </Slide>{' '}
          <Slide index={2}>
            <div
              className="poster-1"
              style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center ',
                backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 90%,
            rgba(21,30,47,1)), url('https://wallpaperaccess.com/full/1923020.jpg')`,
              }}
            >
              <div className="poster-1__left">
                <div className="poster-1__top">
                  <h1>Video Title</h1>
                  <h3>Video Description</h3>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Quae eligendi expedita facere placeat error magni.
                  </p>
                </div>
                <div className="poster-1__bottom">
                  <ButtonBack className="poster__back">
                    <DoubleArrow className="poster__backButton" />
                  </ButtonBack>
                </div>
              </div>

              <div className="poster-1__right">
                <div className="poster__right__play">
                  <PlayCircleOutline className="poster__icons" />
                  <strong>Latest</strong>
                </div>
                <ButtonNext className="poster__button">
                  <DoubleArrow className="poster__icons" />
                </ButtonNext>
              </div>
            </div>
          </Slide>
        </Slider>
      </CarouselProvider>
    </div>
  );
};

export default HeaderCarsoul;
